var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddToPhotosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.061,
    height: 23.061,
    viewBox: "0 0 23.061 23.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-add-to-photos",
    "data-name": "Icon material-add-to-photos",
    d: "M5.306,7.612H3V23.754a2.313,2.313,0,0,0,2.306,2.306H21.448V23.754H5.306ZM23.754,3H9.918A2.313,2.313,0,0,0,7.612,5.306V19.142a2.313,2.313,0,0,0,2.306,2.306H23.754a2.313,2.313,0,0,0,2.306-2.306V5.306A2.313,2.313,0,0,0,23.754,3ZM22.6,13.377H17.989v4.612H15.683V13.377H11.071V11.071h4.612V6.459h2.306v4.612H22.6Z",
    transform: "translate(-3 -3)",
    fill: "#a5a5a5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToPhotosIcon);
export default __webpack_public_path__ + "static/media/add-to-photos-icon.d63c3495ad70ef550a849894a42e6e8b.svg";
export { ForwardRef as ReactComponent };